import React from 'react';
import get from 'lodash/get';
import browserHistory from 'react-router/lib/browserHistory';
import connect from 'react-redux/lib/connect/connect';
import PropTypes from 'prop-types';
import { getLang } from 'redux-pagan';
import registrationLogoWebp from '../../../static/images/registrationLogo.webp';
import AuthenticationContainer from '../../containers/AuthenticationContainer/AuthenticationContainer';
import { userAuthenticationPageTabs } from '../../constants';
import appendLocale from '../../helpers/appendLocale';
import withPageWrapper from '../../containers/PageContainer/PageContainer';
import * as styles from './UserAuthenticationPage.scss';

class UserAuthenticationPage extends React.Component {
  handleTabClick = (type, event) => {
    browserHistory.push(appendLocale(this.props.locale, `/${type}`));
    const hiddenElement = event.currentTarget;
    hiddenElement.scrollIntoView({
      block: 'nearest',
      behavior: 'smooth',
      inline: 'center'
    });
  };

  render() {
    const { translate } = this.props;

    return (
      <div className={styles.wrapper}>
        <AuthenticationContainer
          isRedirectEnabled
          title={translate('authenticationPage', 'welcome')()}
          activeTab={
            get(this.props, 'routeData.location') ||
            userAuthenticationPageTabs.SIGN_IN
          }
          onTabClick={this.handleTabClick}
        />
        <div className={styles.logo}>
          <picture>
            <source srcSet={registrationLogoWebp} type="image/webp" />
            <img
              src="/images/registrationLogo.png"
              alt=""
              width="915"
              height="1036"
              loading="eager"
              decoding="async"
            />
          </picture>
        </div>
      </div>
    );
  }
}

UserAuthenticationPage.propTypes = {
  translate: PropTypes.func,
  locale: PropTypes.string,
  routeData: PropTypes.object
};

const mapStateToProps = (state) => ({
  translate: getLang(state.lang, 'static'),
  locale: state.lang.locale
});

export default connect(mapStateToProps)(withPageWrapper(UserAuthenticationPage));
